import * as Sentry from '@sentry/react';
import { env } from './env';

/** Browser error tracking. Off when VITE_SENTRY_DSN is empty; never sends personal data. */
export function initMonitoring() {
  if (!env.sentryDsn) return;
  Sentry.init({
    dsn: env.sentryDsn,
    release: env.appVersion,
    environment: import.meta.env.MODE,
    sendDefaultPii: false,
    tracesSampleRate: 0.1,
  });
}
